export default "__VITE_ASSET__Uw$NJYns__"